<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import axios from "axios";
    import ScenarioSelect from './ScenarioSelect.svelte';
    import { createEventDispatcher } from 'svelte';

    export let bot;
    export let scenario;
    export let clickIconImage;
    export let clickButtonImageModify;

    let refScenarioContext;
    let refButtonList = [];

    const BUTTON_TYPE_FIX = 'FIX';
    const BUTTON_TYPE_DEFAULT = 'DEFAULT';
    const dispatch = createEventDispatcher();

    onMount(() => {
        jQuery( ".talk-button-ul" ).sortable({
            stop: function( event, ui ) {
                event.target.querySelectorAll(".ordered-button").forEach((e, idx) => {
                    const id = e.dataset.id;
                    bot.defaultChar.activeScenario.changeButtonSeq(id, idx, BUTTON_TYPE_DEFAULT);
                });
                
            }
        });
    });

    const changeButtonTitle = (index, type) => {
        const list = type == BUTTON_TYPE_FIX ? refFixedButtonList : refButtonList;
        let title = list[index].value;
        // 혹시 모를 스크립트 방지x
        title = title.replace(/\<script>.*\<\/script>/gi, '');
        bot.defaultChar.activeScenario.changeButtonTitle(title, index, type);
    }

    const changeIframeButtonOutline = (type, index) => {
        let buttonList = document.getElementById("mobile-frame").contentWindow.document.querySelectorAll(".chat-button-wrapper");
        for (const button of buttonList) {
            button.style.outline = "none";
        }
        if (index == undefined) {
            return;
        }
        if (type == BUTTON_TYPE_FIX) {
            buttonList = document.getElementById("mobile-frame").contentWindow.document.querySelectorAll(".fixed-chat-button");
        } else {
            for (const button of document.getElementById("mobile-frame").contentWindow.document.querySelectorAll(".fixed-chat-button")) {
                button.style.outline = "none";
            }
        }
        buttonList[index].style.outline = "3px solid #DBDDEC";
    }

    const clickButtonDelete = (index, type) => {
        bot.defaultChar.activeScenario.deleteButton(index, type);
    }

    const clickButtonImage = (button) => {
        const buttonId = button.id;
        if (button.buttonImageType === "ICON-DEFAULT" || button.buttonImageType === null) {
            clickIconImage(buttonId);
        } else {
            clickButtonImageModify(buttonId)
        }
    }

    const clickActiveButton = (button) => {
        const iframe = document.getElementById("mobile-frame").contentWindow.document;
        jQuery(".avatalk-contents").animate({scrollTop: 100}, 500);
    }
</script>
<ul class="talk-button-ul">
    {#each scenario.buttonList as button, index}
    <li class="talk-button-wrap ordered-button" data-id={button.id} on:click={()=>clickActiveButton(button)}>
        <div class="talk-button">
            <div class="move"></div>
            {#if button.isTargetTypeDataInput()}
            <div class="data-input-title">타이틀 텍스트</div>   
            {/if}
            <div class="talk-button-form w-form">
                <div id="email-form" name="email-form" data-name="Email Form" method="get" class="button-text-form" class:button-iframe={button.isTargetTypeIframe()} class:button-input={button.isTargetTypeDataInput()}>
                    {#if button.isTargetTypeIframeSelected()}
                    <iframe class="button-iframe" src={button.targetLink} />
                    {:else if button.isTargetTypeIframe()}
                    <div class="button-iframe-wrapper">아래에 유튜브 링크를 넣어주세요!</div>
                    {:else if button.isTargetTypePrivacy()}
                    <textarea type="text" class="button2-text-form story w-input" rows={button.getTittleRows()} placeholder="이벤트 신청 폼이에요~!" value={button.title || ""} bind:this={refButtonList[index]} on:change={(e) => changeButtonTitle(index)} on:click={()=>changeIframeButtonOutline('default', index)} on:mouseleave={()=>changeIframeButtonOutline('default')} />
                    {:else if button.isTargetTypeInput()}
                    <textarea type="text" class="button2-text-form story w-input" rows={button.getTittleRows()} placeholder="답변을 입력해주세요!" value={button.title || ""} bind:this={refButtonList[index]} on:change={(e) => changeButtonTitle(index)} on:click={()=>changeIframeButtonOutline('default', index)} on:mouseleave={()=>changeIframeButtonOutline('default')} />
                    {:else}
                    <textarea class="button2-text-form story w-input" rows={button.getTittleRows()} maxlength="1000" placeholder="버튼에 들어갈 텍스트를 입력해주세요." value={button.title || ""} bind:this={refButtonList[index]} on:change={(e) => changeButtonTitle(index)} on:click={()=>changeIframeButtonOutline('default', index)} on:mouseleave={()=>changeIframeButtonOutline('default')} />
                    {/if}
                    {#if button.isIconRequired()}
                    <img class="pointer" src="/static/images/image-icon.svg" loading="lazy" alt="" on:click={() => clickButtonImage(button)}>
                    {/if}
                </div>
            </div>
            <div class="delete-button pointer" on:click={()=>clickButtonDelete(index)}></div>
        </div>
        <div class="scenario-dropdown">
            <ScenarioSelect {bot} {button}/>
        </div>
    </li>
    {/each}
</ul>
<style>
    .talk-button-ul {
        padding-left: 0px !important;
    }
    .scenario-dropdown {
        position: sticky
    }
    .talk-button {
        margin-top: 20px;
        position: relative;
        width: auto;
    }
    .button-iframe {
        background-color: #99A3B7;
    }
    .button-text-form {
        min-height: 40px;
        height: auto;
        border-radius: 5px;
        padding-top: 2px;
        padding-bottom: 2px;
    }
    .button-iframe {
        width: -webkit-fill-available;
        border-radius: 10px;
        border-width: 0px;
        cursor: default;
        padding: 0px;
    }
    .button-text-form.iframe {
        padding: 0px;
    }

    .button-input {
        background-color: white;
        border: 1px solid #6372FF;
        border-radius: 5px;
    }
    .move {
        cursor: -webkit-grab;
    }

    .button2-text-form.story {
        font-size: 14px;
    }

    .button-iframe-wrapper {
        color: white;
    }

    .button-input input::placeholder {
        color: #BEBEBE;
    }
    .data-input-title {
        position: absolute;
        top: -25px;
        left: 20px;
        font-size: 10px;
        color: #95A1B9;
    }
    .button-text-form textarea {
        min-height: 24px;
    }
    .button-text-form textarea::placeholder {
        vertical-align: middle;
    }
	.name-text-form.story {
		
	}

</style>